const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/consolidation/api-factory');
const serviceFactory = require('../resources/consolidation/service-factory');

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/portfoliooverview/${apiConfig.apiversion}/`
  });

  const service = serviceFactory({ api });
  const p = '[{keys:metaData}].';

  return app => app
    .match(`${p}consolidatesetup.getData`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getConsolidationSetupData(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))

    .match(`${p}consolidatesetup.setData[{keys:branchCode}][{keys:pfId}][{keys:relId}]`, requests =>
      Promise.all(requests.map(({ req, res }) => 
         service.setConsolidationSetupData(req.params)
          .then(response => res.value(response))
          .catch(res.error)
        
      )))

}

module.exports = addRoutes;
